import { render } from "./TaskPanel.vue?vue&type=template&id=0de30dfd&scoped=true"
import script from "./TaskPanel.vue?vue&type=script&lang=js"
export * from "./TaskPanel.vue?vue&type=script&lang=js"

import "./TaskPanel.vue?vue&type=style&index=0&id=0de30dfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de30dfd"]])

export default __exports__